// extracted by mini-css-extract-plugin
export var centerText = "_f6-8";
export var container = "_f6-0";
export var doughnutContainer = "_f6-7";
export var legend = "_f6-a";
export var legendItemColorDisplay = "_f6-b";
export var legendItemLabel = "_f6-d";
export var legendItemValue = "_f6-c";
export var lg = "_f6-5";
export var maxWidth = "_f6-9";
export var md = "_f6-4";
export var responsive = "_f6-6";
export var sm = "_f6-3";
export var xs = "_f6-2";
export var xxs = "_f6-1";